module.exports = __webpack_public_path__ + "static/media/Cloudy-clear at times 1.f7d49f7c.svg";